import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from "swiper";
import 'swiper/css';
import styled from 'styled-components';


function ImageSlider(props) {
  const a = props.imgArr;
  return (
    <Wrapper>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        {a[0].imgArr.map((e) => <SwiperSlide key={e.id}><img src={e.imgSrc} alt="school" /></SwiperSlide>)}
      </Swiper>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  padding:0 0rem;
  position:relative;
  margin-top:15rem; /* added margin-top */
  img{
    width:100%;
    height:50vh;
    transition:all 1s ease;
    object-fit:cover;
  }    
  img:hover{
    transform:scale(1.1);
  }
  .text{
    position:absolute;
    font-size:4rem;
    z-index:100;
    top:5vh;
    left:50%;
    transform:translateX(-50%);
    background-color:rgba(0,0,0,0.5);
    color:white;
    padding:1rem;
  }
  @media (max-width: 768px) {
   img{
    height:40vh;
  }
  .text{
    font-size:3rem;
    top:3vh;
  }
  .modal-content {
    display:none;
  }
}
@media (max-width: 480px) {
  img{
    height:30vh;
  }
  .text{
    font-size:2rem;
    top:2vh;
  }
}
`;

export default ImageSlider;